import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MainFuseDrawerService } from './main-fuse-drawer.service';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'sbd-account-portal-frontend-main-fuse-drawer-header',
  templateUrl: './main-fuse-drawer-header.component.html',
  styleUrls: ['./main-fuse-drawer-header.component.scss'],
  standalone: true,
  imports: [MatIcon, MatIconButton],
})
export class MainFuseDrawerHeaderComponent {
  @Input() title: string;
  @Input() showCloseButton: boolean = false;
  @Input() showBackButton: boolean = false;
  @Output() moveBackEvent = new EventEmitter<void>();
  @Output() closeDrawerEvent = new EventEmitter<void>();

  _mainFuseDrawerService = inject(MainFuseDrawerService);

  onCloseDrawer() {
    this._mainFuseDrawerService.openDrawer.set(false);
  }

  onMoveBack() {
    this.moveBackEvent.emit();
  }
}
